
module.exports = require('./ckeditor');